<div class="page-contents">
  <div class="subBlockContainer">
    <div class="breadcrumbWrapper">
      <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="subBlockContainer flex-direction-row">
      <div class="subBlockContent" id="homepage">
          <div class="item-title-wrapper">
            <!-- <p class="title-wrapper">Dashboard</p> -->
            <div class="title blade-title-font">
              Dashboard
            </div>
              <div class="page-title-description">Welcome to your company dashboard. You’ll find a
                quick snapshot of how you’ve been tracking with us below as well as some quick links to the most visited
                sections of our website to get you started faster.</div>
              <!-- <div class="top-divider"></div> -->
            <!-- <div class="row marginless-container">
    <div class="padding-left-20">
      <div class="infoSection shadow-wrapper account-summary">
        <div class="report-title margin-bottom-12">ACCOUNT SUMMARY</div>
        <loading-icon [currentLoadingStatus]="summaryLodingStatus"></loading-icon>
        <div class="row" [hidden]="summaryLodingStatus">
          <div class="col-md-12">
            <div class="section-divider" *ngIf="getDebtorSummary.out_balance >0">
              <div class="report-data-key">ACCOUNT BALANCE</div>
              <div class="report-data-value">
                <div class="dollarsignleft">$</div>
                <div class="textright">{{ getDebtorSummary.out_balance|number : '1.0-0' }}</div>
              </div>
            </div>
            <div class="section-divider" *ngIf="getDebtorSummary.out_order_count >0">
              <div class="report-data-key">{{ getDebtorSummary.out_order_count }} OPEN
                ORDERS</div>
              <div class="report-data-value">
                <div class="dollarsignleft">$</div>
                <div class="textright">{{ getDebtorSummary.out_order_value|number : '1.0-0' }}</div>
              </div>
            </div>

            <div class="section-divider" *ngIf="getDebtorSummary.out_quote_count >0">
              <div class="report-data-key">{{getDebtorSummary.out_quote_count}} QUOTES
              </div>
              <div class="report-data-value">
                <div class="dollarsignleft">$</div>
                <div class="textright">{{getDebtorSummary.out_quote_value|number : '1.0-0' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>

      <div class="infoSection infoSection-infoBox shadow-wrapper transaction-summary">
        <div class="report-title margin-bottom-12">TRANSACTIONAL SUMMARY</div>
        <loading-icon [currentLoadingStatus]="chartLoadingStatus"></loading-icon>
        <div class="row" [hidden]="chartLoadingStatus">
          <canvas id="chartTransactionalHistory" width="620" height="180"></canvas>
        </div>
      </div>
    </div>
  </div> -->
          </div>
          <div class="page-main-wrapper">
            <!-- <div class="row marginless-container">
              <div class="col-md-12 search-box padding-left-3">
                <div class="gloSearchInputGroup searchInputGroup">
                  <div class="searchIcon" title="Search products (global)">
                    <img src="../images/new_ui/searchIcon-gray.png">
                  </div>
                  <ng-template #tipContent>
                    <div>Start your search here.</div>
                  </ng-template>
                  <input #t="ngbTooltip" class="mr-sm-2 searchbar searchInput margin-right-0"
                    type="text" placement="bottom" [ngbTooltip]="tipContent" placeholder="Start your search" onfocus="this.placeholder=''"
                    onblur="this.placeholder='Start your search'" [(ngModel)]="searchField" (keyup.enter)="search(searchField)">
                </div>
              </div>
            </div> -->

            <ng-template #popContent>
              <p><b>Step 5</b> – Quick access to frequently used shortcuts</p>
              <button class="button button-red button-mid" (click)="previousTourStepFour()">Previous Step</button>
              <button class="button button-red button-mid" (click)="EndTourStep()">End Tour</button>
            </ng-template>

            <div class="row marginless-container" [ngbPopover]="popContent" triggers="manual" #popoverHome="ngbPopover"
              placement="top" *ngIf="authService?.menuLoadingCompleted">



              <!-- no customers menu cards -->
              <ng-container *ngIf="!hasCustomersMenu(); else hasCustomersMenuCards">
                <div  class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                  <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                    <div class="infoSection-title">Quick Start</div>
                    <div class="infoSection-content">Quick links to get to the most popular sections
                      of our website</div>
  
                    <ul class="list-group list-group-flush">
                      <li *ngFor="let item of quickStartMenu" class="list-group-item" (click)="navigateTo(item)">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}} </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                  <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                    <div class="infoSection-title">Transactions</div>
                    <div class="infoSection-content">Easy access to the most used operational features of the site
                    </div>
                    <ul class="list-group list-group-flush">
                      <li *ngFor="let item of accountMenu" class="list-group-item" (click)="navigateTo(item)">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}} </li>
                    </ul>
                  </div>
                </div>
                <div *ngIf="isAU" class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                  <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                    <div class="infoSection-title">Freight Calculator</div>
  
                    <div class="searchInputGroup margin-l-x0">
                      <div class="searchIcon" (click)="search(searchField);">
                        <img src="../images/new_ui/searchIcon-gray.png">
                      </div>
                      <input class="searchInput" type="string" [(ngModel)]="searchInput" (keyup.enter)="searchPostCode()"
                        placeholder="Search postcode" onfocus="this.placeholder=''"
                        onblur="this.placeholder='Search postcode'">
                    </div>
                    <div class="infoSection-content">
                      <div class="freightZoneWrapper">
                        <loading-icon [currentLoadingStatus]="freightLoadingStatus"></loading-icon>
                        <div *ngIf="!freightLoadingStatus">
                          <div *ngIf="zone">
                            <div class="postResponseMessage">{{ postResponse }}</div>
                            <div *ngIf="zone == '1'">
                              <p class="adjust-margin-bottom">Invoice &lt; $500ex = $25ex Freight</p>
                              <p>Invoice &gt; $500ex = FREE Freight</p>
                            </div>                          
                            <div *ngIf="zone !== '1' && zone !== 'Post Code not found'">
                              <!-- <p class="adjust-margin-bottom">Invoice &lt; $300ex = $20ex</p> -->
                              <p class="adjust-margin-bottom">Freight quote required</p>
                             <!--  <p>Freight Invoice &gt; $300ex = Freight quote required</p> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="freight-link">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                          <span class="small-logo-wrapper">
                            <img src="../images/site-icons/delivery-add.svg">
                          </span>
                          &nbsp;&nbsp;
                          <a href="DDFreight Policy.pdf" target="_blank">
                            Freight Policy </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- has customers menu cards -->
              <ng-template #hasCustomersMenuCards>
                <div  class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                  <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                    <div class="infoSection-title">Quick Start</div>
                    <div class="infoSection-content">Quick links to get to the most popular sections
                      of our website</div>
  
                    <ul class="list-group list-group-flush">
                      <li *ngFor="let item of quickStartMenu2" class="list-group-item" (click)="navigateTo(item)">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}} </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                  <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                    <div class="infoSection-title">Company Information</div>
                    <div class="infoSection-content">Keep all of the information we store about your company up to
                      date here
                    </div>
                    <ul class="list-group list-group-flush">
                      <li *ngFor="let item of companyInfoMenu" class="list-group-item" (click)="navigateTo(item)" >
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}} </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 row-eq-height" *ngIf="currentUserModel?.hasAdminAccess == true">
                  <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                    <div class="infoSection-title">Portal Access</div>
                    <div class="infoSection-content">Control who from your company can access our website and place
                      orders with us</div>
                    <ul class="list-group list-group-flush">
                      <li *ngFor="let item of portalMenu" class="list-group-item" [routerLink]="item.menuRouter">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}} </li>
                    </ul>
                  </div>
                </div>
              </ng-template>

              <!-- <div *ngIf="!isAU" class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'"  >
                <div class="infoSection infoSection-infoBox shadow-wrapper">
                  <div class="infoSection-title">Help</div>
                  <div class="infoSection-content font-x9">Ask us a question or discover more about our
                    website in our FAQ</div>
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let item of helpMenu" class="list-group-item"
                      (click)="changeMode($event, item.menuName);navigateTo(item)">
                      <span class="small-logo-wrapper">
                        <img [src]="item.menuIconUrl">
                      </span>
                      &nbsp;&nbsp;{{item.menuName}} </li>
                  </ul>
                </div>
              </div> -->
              <div class="col-lg-12 row-contact-height" [class.highlightSection]="tourStep=='step5'">
                <div class="infoSection infoSection-largeBox shadow-wrapper">
                  <div class="infoSection-title">View Dicker Data's Contact Information
                    <a *ngIf="isAU" class="float-right" href="https://www.dickerdata.com.au/contact" target="_blank">
                      <button class="button button-red button-large">
                        View Details
                      </button>
                    </a>
                    <a *ngIf="!isAU" class="float-right" href="https://www.dickerdata.co.nz/contact" target="_blank">
                      <button class="button button-red button-large">
                        View Details
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              <!-- AU Help tile-->
              <!-- <div *ngIf="isAU" class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                <div class="infoSection infoSection-infoBox shadow-wrapper">
                  <div class="infoSection-title">Help</div>
                  <div class="infoSection-content font-x9">Ask us a question or discover more about our
                    website in our FAQ</div>
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let item of helpMenu" class="list-group-item"
                      (click)="changeMode($event, item.menuName);navigateTo(item)">
                      <span class="small-logo-wrapper">
                        <img [src]="item.menuIconUrl">
                      </span>
                      &nbsp;&nbsp;{{item.menuName}} </li>
                  </ul>
                </div>
              </div> -->
              <!-- <div *ngIf="isAU" class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                <div class="infoSection infoSection-infoBox shadow-wrapper">
                  <div class="infoSection-title">Lorem</div>
                  <div class="infoSection-content font-x9">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </div>
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let item of helpMenu2" class="list-group-item"
                      (click)="changeMode($event, item.menuName);navigateTo(item)">
                      <span class="small-logo-wrapper">
                        <img [src]="item.menuIconUrl">
                      </span>
                      &nbsp;&nbsp;{{item.menuName}} </li>
                  </ul>
                </div>
              </div>
              <div *ngIf="isAU" class="col-lg-4 row-eq-height" [class.highlightSection]="tourStep=='step5'">
                <div class="infoSection infoSection-infoBox shadow-wrapper">
                  <div class="infoSection-title">Lorem</div>
                  <div class="infoSection-content font-x9">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </div>
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let item of helpMenu2" class="list-group-item"
                      (click)="changeMode($event, item.menuName);navigateTo(item)">
                      <span class="small-logo-wrapper">
                        <img [src]="item.menuIconUrl">
                      </span>
                      &nbsp;&nbsp;{{item.menuName}} </li>
                  </ul>
                </div>
              </div> -->
            </div>

            <mat-spinner
              *ngIf="!authService?.menuLoadingCompleted"
              mode="indeterminate"
              class="circle cSPCustomerEntitlements-loading"
              diameter="30"
              style="margin: auto auto;"
            >
            </mat-spinner>
            <div class="promotion">
              <div class="topspot-content" *ngIf="featuredPromotionList?.length > 0" style="padding-bottom: 15px;">
                <div class="flip-featured" *ngFor="let promotion of featuredPromotionList.slice(0, 3)">
                  <div class="flip-featured-inner">
                    <a (click)="onNavigate(promotion.id, promotion?.promotionLink)" target="_blank">
                      <div class="flip-featured-front">
                        <img src="https://marketingdd.blob.core.windows.net/marketing/{{promotion.cloudFileName}}"
                          onError="this.src='https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png';"
                          alt="" target="_blank" />
                      </div>
                      <div class="flip-featured-back">
                        <div class="flip-title">{{promotion.title}}</div>
                        <!-- <div class="font-x12 p-t-10">{{promotion.description | slice:0:200}}</div> -->
                        <div class="flip-link">
                          <a (click)="onNavigate(promotion.id, promotion?.promotionLink)" target="_blank">
                            Click to see more details
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="topspot-content" *ngIf="featuredPromotionList?.length > 3">
                <div class="flip-featured" *ngFor="let promotion of featuredPromotionList.slice(3)">
                  <div class="flip-featured-inner">
                    <a (click)="onNavigate(promotion.id, promotion?.promotionLink)" target="_blank">
                      <div class="flip-featured-front">
                        <img src="https://marketingdd.blob.core.windows.net/marketing/{{promotion.cloudFileName}}"
                          onError="this.src='https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png';"
                          alt="" target="_blank" />
                      </div>
                      <div class="flip-featured-back">
                        <div class="flip-title">{{promotion.title}}</div>
                        <!-- <div class="font-x12 p-t-10">{{promotion.description | slice:0:200}}</div> -->
                        <div class="flip-link">
                          <a (click)="onNavigate(promotion.id, promotion?.promotionLink)" target="_blank">
                            Click to see more details
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div *ngIf="featuredPromotionList.length < 1">No featured promotions to show.</div>
            </div>
          </div>
          <router-outlet></router-outlet>
      </div>
    </div>

    <ng-template #entry></ng-template>